<div [formGroup]="form" class="flex flex-column p-3 gap-4">
  <div class="flex flex-column gap-2 mb-3">
    <label for="catalogItemType" class="font-semibold w-full"
      >{{ "gate_components.import.catalog_type" | translate }}*</label
    >
    <p-select
      formControlName="catalogItemType"
      [options]="catalogItemTypeOptions"
      class="w-full"
      appendTo="body"
      (onChange)="changeType($event)"
    >
      <ng-template let-catalogItemType #selectedItem>
        {{ catalogItemType.label | translate }}
      </ng-template>
      <ng-template let-catalogItemType #item>
        {{ catalogItemType.label | translate }}
      </ng-template>
    </p-select>
  </div>
  <div class="flex flex-column gap-2 mb-3">
    @if (timeoutExampleFile()) {
      <app-timeout></app-timeout>
    } @else if (loadingExampleFile()) {
      <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
    } @else {
      <app-button buttonText="gate_components.import.download_template" (click)="downloadTemplate()"> </app-button>
    }
  </div>
  <div class="flex flex-column gap-3">
    <span>{{ "gate_components.import.explanations.introduction" | translate }}</span>
    @for (column of selectedColumnExplanations; track column) {
      <div class="flex gap-1 ml-3">
        <span class="font-bold"> {{ column.header | translate }} - </span>
        <span> {{ column.explanation | translate }}</span>
      </div>
    }
  </div>
  <div>
    <p-fileUpload
      [showUploadButton]="false"
      [showCancelButton]="false"
      class="w-full"
      styleClass="customFileUpload"
      [chooseLabel]="translate.instant('gate_components.import.choose_file')"
      (onSelect)="onFileSelect($event)"
      accept="text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    >
      <ng-template #content let-uploadedFiles>
        @if (uploadedFiles.length > 0) {
          {{ uploadedFiles.length }}
          {{ "common.files_selected" | translate }}
        }
      </ng-template>
    </p-fileUpload>
  </div>
  @if (failedCsvFilename() && errorType()) {
    @if (errorType() === "partial") {
      <div class="mt-3 mb-3">
        <p-message severity="warn" styleClass="static">
          {{ "gate_components.import.download_failed_import.partial.part_1" | translate }}
          <a (click)="downloadFailedFile($event)">{{ "common.here" | translate }}</a>
          {{ "gate_components.import.download_failed_import.partial.part_2" | translate }}
        </p-message>
      </div>
    }
    @if (errorType() === "error") {
      <div class="mt-3 mb-3">
        <p-message severity="error" styleClass="static">
          {{ "gate_components.import.download_failed_import.error.part_1" | translate }}
          <a (click)="downloadFailedFile($event)">{{ "common.here" | translate }}</a>
          {{ "gate_components.import.download_failed_import.error.part_2" | translate }}
        </p-message>
      </div>
    }
  }

  <!-- Buttons: -->
  <div class="flex justify-content-end gap-2 dialogBtnGroup">
    <app-button id="closeFileDialog" buttonText="common.cancel" (click)="closeDialog()"></app-button>
    @if (timeoutImport()) {
      <app-timeout></app-timeout>
    } @else {
      <app-button
        id="saveFileButton"
        buttonText="common.save"
        [disabled]="!form.valid"
        [loading]="loadingImport()"
        (click)="save()"
      ></app-button>
    }
  </div>
</div>
